/**
 * Deep-link builders that hand navigation off to the phone's native maps apps.
 *
 * The app itself does no routing (a non-goal) — it just opens the right place
 * in Google Maps, Waze, or Apple Maps. Kept pure and free of `window` so it is
 * trivially unit-testable.
 */

/** The minimum a destination needs to be navigable. */
export interface NavTarget {
  lat: number;
  lng: number;
  /** Google Maps Place ID, when known — improves pin accuracy. */
  placeId?: string;
}

function latLng(t: NavTarget): string {
  return `${t.lat},${t.lng}`;
}

/**
 * Google Maps directions link.
 * Adds `destination_place_id` when a Place ID is available so Google resolves
 * the exact venue rather than the raw coordinate.
 */
export function googleMapsUrl(t: NavTarget): string {
  let url = `https://www.google.com/maps/dir/?api=1&destination=${latLng(t)}`;
  if (t.placeId) url += `&destination_place_id=${encodeURIComponent(t.placeId)}`;
  return url;
}

/** Waze deep link that starts navigation to the coordinate. */
export function wazeUrl(t: NavTarget): string {
  return `https://waze.com/ul?ll=${latLng(t)}&navigate=yes`;
}

/** Apple Maps directions link (iOS). */
export function appleMapsUrl(t: NavTarget): string {
  return `maps://?daddr=${latLng(t)}`;
}
